/**
 * Created by wiki on 2017/2/27.
 */
export const SET_APPID = 'SET_APPID'
export const SET_STORES = 'SET_STORES'

export const SET_USERWX = 'SET_USERWX'

export const SET_GATEWAYVER = 'SET_GATEWAYVER'
export const SET_GATEWAYTYPE = 'SET_GATEWAYTYPE'


export const SHOW_NAME_TABS = 'SHOW_NAME_TABS'
export const CHANGE_ADDMEAU_DATA_ONLINE = 'CHANGE_ADDMEAU_DATA_ONLINE'
export const CHANGE_ADDMEAU_DATA_OPEN = 'CHANGE_ADDMEAU_DATA_OPEN'
export const CHANGE_SEARCH_NUMBER = 'CHANGE_SEARCH_NUMBER'


export const CHANGE_WARRANTY = 'CHANGE_WARRANTY'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js